import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\frame-frontend\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\frame-frontend\\src\\app\\App.css");
;
import(/* webpackMode: "eager" */ "C:\\app\\Workspace\\frame-frontend\\src\\app\\index.css");
